import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RewardScreen.css';

const BRAVO_MESSAGES = [
  "Session terminee ! Tu geres.",
  "Bravo ! 25 minutes de pure concentration.",
  "Excellent travail ! Continue comme ca.",
  "Mission accomplie. Tu es en feu !",
  "Impressionnant. Ta discipline paie.",
];

export function RewardScreen() {
  const navigate = useNavigate();
  const [message] = useState(() => BRAVO_MESSAGES[Math.floor(Math.random() * BRAVO_MESSAGES.length)]);
  const [xp] = useState(50);
  const [showXp, setShowXp] = useState(false);

  const stats = (() => {
    try {
      return JSON.parse(localStorage.getItem('focusup_stats') ?? '{}');
    } catch { return {}; }
  })();

  useEffect(() => {
    setTimeout(() => setShowXp(true), 500);
  }, []);

  return (
    <div className="fu-reward">
      <div className="fu-reward-icon">🎉</div>
      <h1 className="fu-reward-title">Bravo !</h1>
      <p className="fu-reward-message">{message}</p>

      <div className={`fu-xp-badge ${showXp ? 'visible' : ''}`}>
        +{xp} XP
      </div>

      {stats.currentStreak > 0 && (
        <div className="fu-streak-badge">
          🔥 {stats.currentStreak} jour{stats.currentStreak > 1 ? 's' : ''} de suite
        </div>
      )}

      <div className="fu-reward-stats">
        <div className="fu-reward-stat">
          <span className="fu-reward-stat-value">{stats.todaySessions ?? 1}</span>
          <span className="fu-reward-stat-label">Sessions aujourd'hui</span>
        </div>
        <div className="fu-reward-stat">
          <span className="fu-reward-stat-value">{stats.todayMinutes ?? 25}'</span>
          <span className="fu-reward-stat-label">Focus aujourd'hui</span>
        </div>
      </div>

      <button className="fu-reward-cta" onClick={() => navigate('/focus')}>
        Encore une session
      </button>
      <button className="fu-reward-home" onClick={() => navigate('/')}>
        Retour a l'accueil
      </button>
    </div>
  );
}
